import {PASearch} from "../PA.Core/PASearch";
import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_Source_Customer_Type_Search_Fields: { [id:string]: ISearchProviderField } = {
    WB_CUSTROLE_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'WB CustomerType Id', columnResourceName: 'colWBRoleId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    ROLE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Role Id', columnResourceName: 'colRoleId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    ENTERPRISE_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Set Id', columnResourceName: 'colSetId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    ROLE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Role Name', columnResourceName: 'colRoleName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    SOURCE_ROLE_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Role Type', columnResourceName: 'colRoleType', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50, profileId: "default", bUseSearchProvidersDistinctValues: true }
    },
    SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Source Id', columnResourceName: 'colSourceId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50, profileId: "default", bUseSearchProvidersDistinctValues: true }
    },
    DEFAULT_IND: {
        type: SearchProviderFieldType.boolean,
        renderOptions: { columnName: 'Default', columnResourceName: 'colDefaultId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 1 }
    },
    MANUAL_IND: {
        type: SearchProviderFieldType.boolean,
        renderOptions: { columnName: 'Manual', columnResourceName: 'colManualId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 1 }
    },
    CUSTM_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Assigned Customer Type', columnResourceName: 'colCustomerTypeName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256, profileId: "default", bUseSearchProvidersDistinctValues: true }
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colCustomerTypeMDSet', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256, profileId: "default", bUseSearchProvidersDistinctValues: true  }
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'WB MDSet Id', columnResourceName: 'colWBMDSetId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
};

const SourceCustomerTypeSearchProviderBasis: ISearchProvider = {
    keyFields: {
        id: 'WB_CUSTROLE_ID',
        id_ui: 'ROLE_ID',
        name: 'ROLE_NAME'
    },

    searchProviderFields: vUI_Source_Customer_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
            const findRequest = SearchUtils.makeSearchRequest(
                searchOptions,
                'vUI_Source_Customer_Type_Search',
                this.searchProviderFields,
                []
            );

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
                let searchRequestSubset: { where?: { [id: string]: any } } = {}
                let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                    'vUI_Source_Customer_Type_Search',
                    this.searchProviderFields,
                    [fieldName])


                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(_.map(res, (aRow) => {
                            return aRow[fieldName]
                        }))
                    })
                    .catch((err) => {
                        error(err)
                    })
            }
        )
    }
};

const SourceCustomerTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "SourceCustomerTypeSearchProfileByName" },

    profileFilter: [
        { profileFilterName: 'Role Id', searchProviderFieldId: 'ROLE_ID', renderOptions: {} },
        { profileFilterName: 'Role Name', searchProviderFieldId: 'ROLE_NAME', renderOptions: {} },
        { profileFilterName: 'Customer Type', searchProviderFieldId: 'CUSTM_NAME', bMultiSelect: true, renderOptions: {} },
        { profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', bMultiSelect: true, renderOptions: {} },
        { profileFilterName: 'Source Id', searchProviderFieldId: 'SOURCE_ID', bMultiSelect: true, renderOptions: {} },
        { profileFilterName: 'Role Type', searchProviderFieldId: 'SOURCE_ROLE_TYPE',bMultiSelect: true,  renderOptions: {} },
    ], // ISearchFields
    profileDisplayFields: [
        'ROLE_ID','ROLE_NAME', 'SOURCE_ROLE_TYPE', 'CUSTM_NAME','MDSET_NAME', 'SOURCE_ID', 'MANUAL_IND', 'DEFAULT_IND'
    ], // Search Provider Field Name (Use to Generate Grid Columns)
    profileHiddenFields: ['SOURCE_ROLE_TYPE','DEFAULT_IND'],
    profileSearchProvider: SourceCustomerTypeSearchProviderBasis,

    profileSortIdDefault: "",
    profileSorts: []
};

const SourceCustomerTypeSearch: ISearch = {
    searchName: "Find Source Customer Type",
    renderOptions: { ui5ResourceId: "SourceCustomerTypeSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [SourceCustomerTypeSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("SourceCustomerTypeBO","SourceCustomerType", SourceCustomerTypeSearch, "Source Customer Type Search")
export { SourceCustomerTypeSearch };
